import styled from '@emotion/styled'
import { typography } from '@resiliatech/birdsong'

export const SectionTitle = styled.p`
  ${typography.baseline.regularSans}
  margin-top: 0;
`
